<template>
  <div class="flex items-center justify-between px-3 py-2 border-b border-gray-200 bg-white shrink-0 text-sm">
    <div class="flex flex-col min-w-0">
      <span class="font-medium truncate text-gray-800">{{ name }}</span>
      <span v-if="subtitle" class="text-xs text-gray-400 truncate">{{ subtitle }}</span>
    </div>
    <div class="flex items-center gap-1 shrink-0">
      <slot name="actions" />
    </div>
  </div>
</template>
<script setup>
defineProps({ name: { type: String, default: '' }, items: Array, subtitle: String });
</script>
